import type { UserDto } from '@issuemanager/api-client';
import { useEventCallback } from '@mui/material';
import { FakeDropdownBox } from '../../../filters';
import { UserMultipleSelector } from '../../../inputs';
import { useDataGridContext } from '../../data-grid-context';
import type { ExtendedGridColumnHeaderProps } from '../../types';
import { ContainerPopper } from './container-popper';

export function DataGridUserFilter(params: ExtendedGridColumnHeaderProps) {
  const context = useDataGridContext();
  const value: UserDto[] = context.filterModel[params.field] ?? [];

  const handleChange = useEventCallback((value: UserDto[]) => {
    context.setFilterModel((prevState) => ({
      ...prevState,
      [params.field]: value,
    }));
  });

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {value.length > 0 ? value.map((c) => c.name).join(', ') : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <UserMultipleSelector
          open
          value={value}
          onChange={handleChange}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
